/**
 * The Tracking class provides methods for sending tracking events to backend endpoints
 * and integrating with external analytics tools such as Amplitude and Google Analytics.
 */
export default class Tracking {
  /**
   * Send event to backend tracking endpoint (Amplitude pipeline).
   * @param eventName
   * @param properties
   * @param {function|null} callback
   */
  static amplitudeTracking(eventName, properties = {}, callback = null) {
    const payload = {
      event_name: eventName,
      properties,
    };

    fetch('/api/tracking', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
      },
      body: JSON.stringify(payload),
    }).then(r => {
      if (callback) callback(r);
    });
  }

  static trackGA(eventName, properties = {}, dataLayer = null) {
    const dl = dataLayer || window.dataLayer;
    const payload = {
      event: eventName,
      ...properties,
    };

    // Only add mandatory context keys when present (non-null/non-empty)
    if (window.brandCountry) payload.country = window.brandCountry;
    if (window.brandName) payload.brand = window.brandName;
    if (window.locale) payload.locale = window.locale;

    dl.push(payload);
  }
}
